import { RootCauseGenericBarGraphGroupResult } from 'libs/end-to-end/src/root-cause-analysis';
import React, { useMemo } from 'react';
import { ConfigColors } from 'libs/end-to-end/src/types/branding/colors';
import { GenericBarChart } from 'apps/sigma2-ui/src/pages/FocusAreaPage/GenericBarChart';
import { GraphLegend } from 'apps/sigma2-ui/src/components/ui/GraphLegend';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';

export const RootCauseGenericBarChart = ({
  result,
  download,
  treatmentLevel,
  yAxisText,
  graphClassName,
}: {
  result: RootCauseGenericBarGraphGroupResult;
  download: React.ReactNode;
  treatmentLevel: string;
  yAxisText: string;
  graphClassName: string;
}) => {
  const keys = useMemo(() => {
    return result.x;
  }, [result]);

  // come up with a hex color that is pleasant for all keys
  const colors = useMemo(() => {
    const colorOptions = Object.entries(ConfigColors).map(
      ([, v]) => v.Primary.raw,
    );

    return keys.map((_, i) => colorOptions[i % colorOptions.length]);
  }, [keys]);

  return (
    <>
      <div className="pl-[100px] pr-5 mb-4">
        <Spacing direction="horizontal" size="justify-between">
          <Spacing
            direction="vertical"
            size="w-full"
            className="justify-center"
          >
            {keys.map((key, i) => (
              <GraphLegend color={colors[i]} key={key}>
                {key}
              </GraphLegend>
            ))}
          </Spacing>

          {download}
        </Spacing>
      </div>
      <div className={graphClassName}>
        <GenericBarChart
          result={result}
          controlVariable={result.control_variable}
          demographicKey={treatmentLevel}
          yAxisText={yAxisText}
          colors={colors}
        />
      </div>
    </>
  );
};
